import React, { useEffect, useRef, useState } from 'react';

const slidesData = [
    {
        image: 'https://albidayahgroups.com/Media/Restaurant/DSC07644.JPG',
        businessType: 'Restaurant',
        shortName: 'Restaurant',
        author: 'The Brew House',
        title: 'Fine Dinning',
        topic: 'Carousel',
        description:
            'Savor every bite in a warm, inviting atmosphere where handcrafted dishes meet the heart of the city.',
            link: "/restaurant",
    },
    {
        image: 'https://albidayahgroups.com/Media/Logistics/logistics.jpg',
        businessType: 'Logistics',
        shortName: 'Food',
        author: 'AL-BIDAYAH',
        title: 'Lightning fast',
        topic: 'Carousel',
        description:
            'Streamline your supply chain with reliable service and seamless delivery at the core of your business.',
            link: "https://laksirigroup.com/",
            target: "blank",
    },
    {
        image: 'https://albidayahgroups.com/Media/Properties/photorealistic-house-with-wooden-architecture-timber-structure.jpg',
        businessType: 'Properties',
        shortName: 'Realty',
        author: 'Sunrise Estates',
        title: 'Modern Villa',
        topic: 'Carousel',
        description:
            'Discover elegant properties with stunning architecture and prime locations for living or investment.',
            link: "/properties",
    },
    {
        image: 'https://albidayahgroups.com/Media/Travel/trave%203.jpg',
        businessType: 'Travel',
        shortName: 'Travel',
        author: 'JetWay Tours',
        title: 'Exotic Destinations',
        topic: 'Carousel',
        description:
            'Plan your next adventure with customized travel packages.',
            link: "https://riatravel.my/services/",
            target: "blank",
    },
    {
        image: 'https://albidayahgroups.com/Media/Home/edu-1.jpg',
        businessType: 'Education',
        shortName: 'Education',
        author: 'JetWay Tours',
        title: 'Inspire',
        topic: 'Carousel',
        description:
            'Customized programs for global education and growth.',
            link: "https://mhcockpit.com",
            target: "blank",
    },
];


const Verticals = () => {
    // State: array of indexes representing current order
    const [order, setOrder] = useState([0, 1, 2, 3, 4]);
    const carouselRef = useRef(null);
    const timeRunning = 3000;
    const timeAutoNext = 7000;

    const timeoutRef = useRef(null);
    const autoRunRef = useRef(null);

    // Animate class toggle
    const toggleClass = (cls) => {
        if (!carouselRef.current) return;
        carouselRef.current.classList.add(cls);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            carouselRef.current.classList.remove(cls);
        }, timeRunning);
    };

    // Next slide: move first item to end
    const nextSlide = () => {
        setOrder((prev) => {
            const newOrder = [...prev.slice(1), prev[0]];
            toggleClass('next');
            resetAutoRun();
            return newOrder;
        });
    };

    // Prev slide: move last item to front
    const prevSlide = () => {
        setOrder((prev) => {
            const newOrder = [prev[prev.length - 1], ...prev.slice(0, prev.length - 1)];
            toggleClass('prev');
            resetAutoRun();
            return newOrder;
        });
    };

    // Auto run logic
    const resetAutoRun = () => {
        clearTimeout(autoRunRef.current);
        autoRunRef.current = setTimeout(() => {
            nextSlide();
        }, timeAutoNext);
    };

    useEffect(() => {
        resetAutoRun();
        return () => {
            clearTimeout(autoRunRef.current);
            clearTimeout(timeoutRef.current);
        };
    }, []);

    return (
        <div className="carousel w-[100vw]" ref={carouselRef}>
            <div className="list">
                {order.map((idx) => {
                    const slide = slidesData[idx];
                    return (
                        <div className="item" key={idx}>
                            <div className="relative w-full h-full">
                                <img src={slide.image} alt={`Slide ${idx + 1}`} className="w-full h-full object-cover" />
                                <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/70 pointer-events-none" />
                            </div>
                            <div className="content">
                                {/* <div className="author">{slide.author}</div> */}
                                <div className="title">{slide.title}</div>
                                <div className="topic">{slide.businessType}</div>
                                <div className="des text-xl pb-5">{slide.description}</div>
                                <div>
                                    <a href={slide.link} target={slide.target} className='bg-white text-black p-2 rounded-xl buttons'>See More</a>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="thumbnail">
                {(() => {
                    const shiftedOrder = [...order.slice(1), order[0]];
                    return shiftedOrder.map((idx) => {
                        const slide = slidesData[idx];
                        return (
                            <div className="item" key={'thumb-' + idx}>
                                <div className="relative w-full h-full">
                                    <img onClick={nextSlide} src={slide.image} alt={`Thumb ${idx + 1}`} className="w-full h-full object-cover" />
                                    <div className="absolute inset-0 bg-black/20 pointer-events-none rounded-[20px]" />
                                </div>
                                <div className="content text-white">
                                    <div className="title pb-2">{slide.businessType}</div>
                                    {/* <div className="des">{slide.businessType}</div> */}
                                </div>
                            </div>
                        );
                    });
                })()}
            </div>

            <div className="arrows">
                <button id="prev" onClick={prevSlide}>
                    &lt;
                </button>
                <button id="next" onClick={nextSlide}>
                    &gt;
                </button>
            </div>

            {/* <div className="time"></div> */}
        </div>
    );
};

export default Verticals;
